// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7836) return "static/chunks/7836-aa3743f77d98d66c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"566":"e627732644e0a22b","1557":"47d91aafb3a42e4b","2283":"7b8d9d73fa03bbf1","3158":"231a268c6e14518c","6843":"3f8156b20ee77363","8031":"f414fd58b3d4c1e3","9389":"a521757cb19807ac"}[chunkId] + ".js";
};